module.exports = __webpack_public_path__ + "static/media/spe_prototype_img_bg.497f3aff.png";